import { Component, Inject, OnInit } from '@angular/core';
import { AnModalService, MODAL_DATA } from '@autonation/dt-an-components-lib/an-modal';
import { BaseTooltipModalComponent } from '../base-tooltip-modal/base-tooltip-modal.component';
import { PricingStack, ItemsLabels, Item } from '../../../../interfaces/price-details.interface';


interface Data {
  title: string;
  pricingStack: PricingStack;
  priceItemsLabels: ItemsLabels[];
}

interface PriceItem extends Item {
  sign?: string;
  bold?: boolean;
  tooltip?: boolean;
  tooltipText?: string;
}

@Component({
  selector: 'lib-price-details-modal',
  templateUrl: './price-details-modal.component.html',
  styleUrls: ['./price-details-modal.component.scss'],
  standalone: false
})
export class PriceDetailsModalComponent implements OnInit {
  jackedupTitle = 'Something is jacked up';
  jackedupSubtitle = 'Sorry, there was a problem with your request.';
  tryAgain = 'Try Again';
  estimated = 'estimated';

  title: string;
  items: PriceItem[] = [];
  priceItemsLabels: ItemsLabels[];
  topItems: PriceItem[] = [];
  contentItems: PriceItem[] = [];

  balanceDue: Item;

  constructor(
    @Inject(MODAL_DATA) public data: Data,
    private modalService: AnModalService
  ) { }

  ngOnInit(): void {
    if (this.data?.pricingStack?.Items) {
      this.title = this.data?.title.toLowerCase();

      this.data?.pricingStack?.Items
        .filter(item => item.Value != '0')
        .sort((a, b) => a.SortOrder - b.SortOrder)
        .forEach(item => {
          if (item.Items?.length > 0) {
            item.Items.forEach(subItem => this.items.push(subItem));
          } else {
            this.items.push(item);
          }
        });

      this.priceItemsLabels = this.data?.priceItemsLabels;

      if (this.priceItemsLabels) {
        this.items.map(item => {
          item.tooltipText = this.priceItemsLabels.find(priceItem => priceItem.Key === `${item.Name}TooltipText`)?.Value;
          item.Name = this.priceItemsLabels.find(priceItem => priceItem.Key === item.Name)?.Value || item.Name;
          return item;
        });
      }

      const vehicleSellingPrice = this.items.find(item => item.LowestName.toLowerCase() === 'vehiclesellingprice');
      const autonationPrice = this.items.find(item => item.LowestName.toLowerCase() === 'autonationprice');

      this.items.forEach(item => {
        if (item.LowestName.toLowerCase() === 'balancedue') {
          this.balanceDue = item;
        } else if (item.LowestName.toLowerCase() === 'autonation1price') {
          this.topItems.push({ ...item, sign: '', bold: true });
        } else if (item.LowestName.toLowerCase() === 'msrp') {
          this.topItems.push({ ...item, sign: '', bold: false });
        } else if (item.LowestName.toLowerCase() === 'autonationprice') {
          this.contentItems.push({ ...item, sign: '', bold: true })
        } else if (item.LowestName.toLowerCase() === 'autonationsavings') {
          this.topItems.push({ ...item, sign: '-', bold: false });
        } else if (item.LowestName.toLowerCase() === 'vehiclesellingprice') {
          if (autonationPrice?.Value != item.Value) {
            this.contentItems.push({ ...item, sign: '', bold: true })
          }
        } else if (item.LowestName.toLowerCase() === 'tax' || item.Name.toLowerCase() === 'dealerfee') {
          this.contentItems.push({ ...item, sign: '+', bold: false })
        } else if (item.LowestName.toLowerCase() === 'difference') {
          if (vehicleSellingPrice?.Value != item.Value) {
            this.contentItems.push({ ...item, sign: '+', bold: false })
          }
        } else if (item.Items?.length > 0) {
          item.Items.forEach(subItem => {
            this.contentItems.push({ ...subItem, sign: '+', bold: false })
          });
        } else {
          this.contentItems.push({ ...item, sign: '+', bold: false })
        }
      });

      if (this.balanceDue == undefined) {
        this.balanceDue = this.data?.pricingStack?.Items.find(item => item.LowestName.toLowerCase() === 'balancedue');
      }
    }
  }

  closeModal() {
    this.modalService.close();
  }

  openTooltip(item: PriceItem) {
    this.modalService.open(BaseTooltipModalComponent, {
      title: item.Name,
      message: item.tooltipText
    }, {
      maxWidth: '300px',
      backdropColor: 'transparent',
      mobileFullSize: false
    });
  }

}
